const s=(s,t=1)=>{const r=s.substr(1,2),a=s.substr(3,2),e=s.substr(5,2);return`rgba(${parseInt(r,16)},${parseInt(a,16)},${parseInt(e,16)},${t})`};export{s as default};
